import styled from 'styled-components';

export const InputWrapper = styled.div`
  margin-right: 30px;
`;
